
import type { TreeProps } from 'ant-design-vue'
/*
    showAddBtn:对树插入新增按钮
    removeAddBtn:删除树新增按钮
*/
export default function changeAddBtn() {
  let num = 999999
  const showAddBtn = (needAddData:TreeProps['treeData']) => {
    needAddData?.forEach((item) => {
      if (item.children) {
        num = num + 1
        item.children.push({
          title: '新增',
          type: 'add',
          class: 'isExpendBg',
          key: num,
          data: item
        })
        showAddBtn(item.children)
      } else if (item.parentId === '-1' && !item.children) {
        item.children = [{
          title: '新增',
          type: 'add',
          class: 'isExpendBg',
          key: num,
          data: item
        }]
      } else if (item.parentId !== -1 && !item.children && item.type !== 'add') {
        num = num + 1
        item.children = [{
          title: '新增',
          type: 'add',
          class: 'isExpendBg',
          key: num,
          data: item
        }]
      }
    })

    return needAddData
  }
  const removeAddBtn = (needRemoveData:TreeProps['treeData']) => {
    needRemoveData?.forEach(item => {
      item.children = item.children?.filter((item) => {
        return item.type !== 'add'
      })
      if (item.children) {
        removeAddBtn(item.children)
      }
    })

    return needRemoveData
  }
  return { showAddBtn, removeAddBtn }
}
